export const ASSIGN_TOOL_ID = 'assign-patients-tool';
export const WORKING_QUEUE_ID = 'ccm-console-working-queue';
